import React, { useEffect, useState, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FeaturesSection } from './components/FeaturesSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ServiceModelSection } from './components/ServiceModelSection';
import { IntakeFormSection } from './components/IntakeFormSection';
import { WhoItsForSection } from './components/WhoItsForSection';
import { PartnerSection } from './components/PartnerSection';
import { WhySparkHRSection } from './components/WhySparkHRSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { InsightsPage } from './components/InsightsPage';
import { ArticlePage } from './components/ArticlePage';
import { FounderPage } from './components/FounderPage';
import { articles } from './data/articles';
export function App() {
  useEffect(() => {
    // Google Analytics
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-MDBZZ02YTZ';
    script.async = true;
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-MDBZZ02YTZ');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  document.title = 'SparkHR — Modern People Operations for Growing Companies';
  const [currentView, setCurrentView] = useState<any>('home');
  const handleNavigate = (view: any) => {
    setCurrentView(view);
    window.scrollTo(0, 0);
  };
  const renderContent = () => {
    if (currentView === 'insights') {
      return <InsightsPage onNavigate={handleNavigate} data-id="element-0" />;
    }
    if (currentView === 'founder') {
      return <FounderPage onNavigate={handleNavigate} data-id="element-1" />;
    }
    if (currentView?.article) {
      const article = articles.find(a => a.slug === currentView.article);
      if (article) {
        return <ArticlePage article={article} onNavigate={handleNavigate} data-id="element-2" />;
      }
      return <InsightsPage onNavigate={handleNavigate} data-id="element-3" />;
    }
    return <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <FeaturesSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <ServiceModelSection data-id="element-9" />
        <IntakeFormSection data-id="element-10" />
        <WhoItsForSection data-id="element-11" />
        <PartnerSection data-id="element-12" />
        <WhySparkHRSection data-id="element-13" />
        <FinalCTASection data-id="element-14" />
      </main>;
  };
  return <div className="min-h-screen bg-white" data-id="element-15">
      <Navbar onNavigate={handleNavigate} currentView={currentView} data-id="element-16" />
      {renderContent()}
      <Footer data-id="element-17" />
    </div>;
}